import { useMemo } from 'react';

import { IChartData } from '../../Chart';
import {
  SpendingHistoryBarChartData,
  UsageHistoryDataMapped,
} from '../../../types';

type TData =
  | IChartData[]
  | UsageHistoryDataMapped[]
  | SpendingHistoryBarChartData[];

interface IUseContentProps {
  data?: TData;
  isLoading?: boolean;
}

const hasData = (data?: TData): boolean => {
  if (!data || data.length === 0) {
    return false;
  }

  return data.some(item => {
    if ('value' in item) {
      return Boolean(item.value);
    }
    if ('calls' in item) {
      return Boolean(item.calls);
    }
    if ('paygSpending' in item || 'dealSpending' in item) {
      return Boolean(item.paygSpending) || Boolean(item.dealSpending);
    }

    return false;
  });
};

export const useContent = ({ data, isLoading }: IUseContentProps) =>
  useMemo(() => {
    const hasChart = !isLoading && hasData(data);
    const hasPlaceholder = !isLoading && !hasChart;

    return { hasChart, hasPlaceholder, hasPreloader: isLoading };
  }, [data, isLoading]);
